/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import * as types from "../../types/primitives.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  CompressorScheduleStep,
  CompressorScheduleStep$inboundSchema,
} from "./compressorschedulestep.js";

/**
 * MPC compressor sequencing forecast extracted from the agent schedule
 */
export type CompressorScheduleForecast = {
  /**
   * Ordered list of compressor names (row labels)
   */
  compressors: Array<string>;
  /**
   * Timestamped MPC sequence states, ordered chronologically
   */
  steps: Array<CompressorScheduleStep>;
};

/** @internal */
export const CompressorScheduleForecast$inboundSchema: z.ZodType<
  CompressorScheduleForecast,
  z.ZodTypeDef,
  unknown
> = z.object({
  compressors: z.array(types.string()),
  steps: z.array(CompressorScheduleStep$inboundSchema),
});

export function compressorScheduleForecastFromJSON(
  jsonString: string,
): SafeParseResult<CompressorScheduleForecast, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => CompressorScheduleForecast$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'CompressorScheduleForecast' from JSON`,
  );
}
